// FETCH ALL PROPERTIES FROM MENU MASTER
export const FETCH_YEAR_MASTER_REQUEST = 'FETCH_YEAR_MASTER_REQUEST';
export const FETCH_YEAR_MASTER_SUCCESS = 'FETCH_YEAR_MASTER_SUCCESS';
export const FETCH_YEAR_MASTER_FAILURE = 'FETCH_YEAR_MASTER_FAILURE';

// CREATE PROPERTIES FOR MENU MASTER
export const CREATE_YEAR_MASTER_REQUEST = 'CREATE_YEAR_MASTER_REQUEST';
export const CREATE_YEAR_MASTER_SUCCESS = 'CREATE_YEAR_MASTER_SUCCESS';
export const CREATE_YEAR_MASTER_FAILURE = 'CREATE_YEAR_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_YEAR_MASTER = 'CREATE_USER_FORM_YEAR_MASTER';


// UPDATE PROPERTIES FOR MENU MASTER
export const UPDATE_YEAR_MASTER_REQUEST = 'UPDATE_YEAR_MASTER_REQUEST';
export const UPDATE_YEAR_MASTER_SUCCESS = 'UPDATE_YEAR_MASTER_SUCCESS';
export const UPDATE_YEAR_MASTER_FAILURE = 'UPDATE_YEAR_MASTER_FAILURE';

// FETCH SINGLE MENU
export const FETCH_SINGLE_YEAR_MASTER_REQUEST = 'FETCH_SINGLE_YEAR_MASTER_REQUEST';
export const FETCH_SINGLE_YEAR_MASTER_SUCCESS = 'FETCH_SINGLE_YEAR_MASTER_SUCCESS';
export const FETCH_SINGLE_YEAR_MASTER_FAILURE = 'FETCH_SINGLE_YEAR_MASTER_FAILURE';

// DELETE PROPERTIES FOR MENU MASTER
export const DELETE_YEAR_MASTER_REQUEST = 'DELETE_YEAR_MASTER_REQUEST';
export const DELETE_YEAR_MASTER_SUCCESS = 'DELETE_YEAR_MASTER_SUCCESS';
export const DELETE_YEAR_MASTER_FAILURE = 'DELETE_YEAR_MASTER_FAILURE';

// USERFORM RESET

export const YEAR_MASTER_USERFORM_RESET = 'YEAR_MASTER_USERFORM_RESET';
